
import Vue from "vue";
import { checkIsMobile, addScript, addLink } from "./uitls";
// import { addScript, addLink } from "./uitls";

const isMobile = checkIsMobile();

let PageHeader: Vue.AsyncComponent;
let PageContent: Vue.AsyncComponent;
let PageFooter: Vue.AsyncComponent;

if (isMobile) {
  PageHeader = () => import("./components/sp/PageHeader.vue");
  PageContent = () => import("./components/sp/PageContent.vue");
  PageFooter = () => import("./components/sp/PageFooter.vue");
} else {
  PageHeader = () => import("./components/pc/PageHeader.vue");
  PageContent = () => import("./components/pc/PageContent.vue");
  PageFooter = () => import("./components/pc/PageFooter.vue");
}

export default Vue.extend({
  name: "App",
  components: {
    PageHeader,
    PageContent,
    PageFooter,
  },
  metaInfo() {
    return {
      title: this.$t("sorrypage error") as string,
      titleTemplate: `%s|${this.$t("sorrypage tab common")}`,
    };
  },
  mounted() {
    if (this.$isMobile) {
      addScript(`${this.$baseURL}js/sp/common.js`);
      addLink(`${this.$baseURL}css/sp/common.css`);
    } else {
      addScript(`${this.$baseURL}js/pc/common.js`);
      addLink(`${this.$baseURL}css/pc/common.css`);
    }
  },
});
